export default __webpack_public_path__ + "static/comparison-background-b9935ae8c5e2956f1f04c1fa2bfc4517.png";